import { EmailDomainEntity } from 'src/types/entities/EmailDomain'
import { EmailDomain } from 'src/types/generated'

export const EmailDomainTranslator = {
  toEntity: (domain: EmailDomain): EmailDomainEntity => ({
    allowedDomain: domain.allowedDomain ?? null,
  }),

  toEntities: (domains: (EmailDomain | null)[] = []): EmailDomainEntity[] => {
    return domains
      .filter((domain): domain is EmailDomain => domain !== null)
      .map(domain => EmailDomainTranslator.toEntity(domain))
  },
} as const
